import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-slate-900 text-slate-300 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-violet-400 hover:text-violet-300 mb-8">
          <ArrowLeft className="w-4 h-4" />
          Back to CreatorFlow
        </Link>
        
        <h1 className="text-3xl font-bold mb-2 text-white">Terms of Service</h1>
        <p className="text-slate-500 mb-8">Effective Date: February 2026</p>
        
        <div className="space-y-6 text-slate-400">
          <p>Welcome to CreatorFlow. By accessing or using CreatorFlow, you agree to the following terms:</p>
          
          <section>
            <h2 className="text-xl font-semibold text-slate-200 mb-2">1. Use of Service</h2>
            <p>CreatorFlow provides AI-powered content generation tools. You agree to use the service lawfully and not for harmful, abusive, or illegal activities.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-slate-200 mb-2">2. Accounts</h2>
            <p>You are responsible for maintaining the confidentiality of your account and login credentials.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-slate-200 mb-2">3. Credits & Payments</h2>
            <ul className="list-disc list-inside space-y-1">
              <li>Credits are required for AI generation features.</li>
              <li>Subscription credits reset monthly (no rollover).</li>
              <li>Purchased credits do not expire.</li>
              <li>Payments are processed securely through PayPal.</li>
              <li>We do not store your payment details.</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-slate-200 mb-2">4. Refund Policy</h2>
            <p>Due to the digital nature of AI-generated content, refunds are not guaranteed and are handled on a case-by-case basis.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-slate-200 mb-2">5. Service Availability</h2>
            <p>We aim to provide reliable service but do not guarantee uninterrupted availability.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-slate-200 mb-2">6. Modifications</h2>
            <p>We may update pricing, features, or these terms at any time.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-slate-200 mb-2">7. Termination</h2>
            <p>We reserve the right to suspend or terminate accounts that violate these terms.</p>
          </section>
          
          <section className="pt-4 border-t border-slate-700">
            <p>
              <span className="text-slate-300">Contact: </span>
              <a href="mailto:support@creatorflow.website" className="text-violet-400 hover:text-violet-300">
                support@creatorflow.website
              </a>
            </p>
          </section>
        </div>
        
        <div className="mt-12 pt-6 border-t border-slate-700 flex gap-6 text-sm">
          <Link to="/privacy" className="text-violet-400 hover:text-violet-300">Privacy Policy</Link>
          <Link to="/help" className="text-violet-400 hover:text-violet-300">Help & Support</Link>
        </div>
      </div>
    </div>
  );
}
